export default __webpack_public_path__ + "static/media/Pin.1d67ac0d.svg";